import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";
import {
  getMessaging,
  getToken,
  isSupported as messagingIsSupported,
  onMessage,
} from "firebase/messaging";
import {
  getAnalytics,
  isSupported as analyticsIsSupported,
} from "firebase/analytics";
import { firebaseConfig } from "env/runtimeEnv";

const isWebView =
  window.navigator.userAgent.includes("wv") ||
  window.navigator.userAgent.includes("WebView") ||
  window.ReactNativeWebView !== undefined ||
  window.navigator.userAgent.includes("ReactNative") ||
  !window.navigator.serviceWorker;

/*
Commented out the measurementId: undefined
 */

const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn("Failed to set authentication persistence:", error);
});

// Analytics (optional, only if measurementId is provided)
let analytics;
if (firebaseConfig.measurementId) {
  analyticsIsSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log("📊 Firebase Analytics initialized");
    }
  });
} else {
  console.log(
    "⚠️ Firebase Analytics not configured - no measurementId provided"
  );
}

let dbInstance = null;
export const getDb = () => {
  if (!dbInstance) {
    try {
      dbInstance = initializeFirestore(app, {
        localCache: memoryLocalCache(),
      });
    } catch (e) {
      console.warn("⚠️ Failed to initialize Firestore:", e);
    }
  }
  return dbInstance;
};

let messaging = null;
if (!isWebView) {
  messagingIsSupported()
    .then((supported) => {
      if (!supported) {
        console.log(
          "🔧 Firebase messaging not supported in this browser; skipping initialization"
        );
        return;
      }
      try {
        messaging = getMessaging(app);
      } catch (e) {
        console.warn("⚠️ Firebase messaging initialization failed:", e);
      }
    })
    .catch((e) => {
      console.warn("⚠️ Firebase messaging support check failed:", e);
    });
} else {
  console.log(
    "🔧 WebView detected - skipping Firebase messaging initialization"
  );
}

export const storage = getStorage(
  app,
  "gs://tujus-pwa-dev.firebasestorage.app"
);
export { app, analytics, messaging, getToken, onMessage };
